import Discrepancy from ".";

export const discrepancytRoutes = [
  {
    path: "/discrepancies",
    element: <Discrepancy />,
  },
];
